<span [innerHtml]="diffText | linky"></span>
